export default __webpack_public_path__ + "static/media/pezodromia_amea.0a2994c8.svg";